export const creditReportDisclosure = {
  v1: (
    <ul>
      <li>
        By continuing with the check eligibility process and viewing your offer(s), you understand
        and agree that you are authorizing NetCredit and/or Republic Bank &amp; Trust Company
        (&ldquo;Republic&rdquo;) and/or Transportation Alliance Bank, Inc. d/b/a TAB Bank
        (&ldquo;TAB Bank&rdquo;) and/or Quill Bank (&ldquo;Quill Bank&rdquo;) to obtain
        consumer reports and related information about you from one or more consumer reporting
        agencies, such as TransUnion and other national databases, for pre-qualification purposes
        only. Your credit score will not be impacted by this pull.
      </li>
      <li>
        If you apply for a loan after viewing your available offer(s), you authorize NetCredit
        and/or Republic and/or TAB Bank and/or Quill Bank to obtain credit reports each time you
        request a loan, during the process of closing a loan, or at various times during the term of
        your loan, in connection with the issuing, servicing, monitoring, collection, or enforcement
        of the loan. Your credit score may be impacted by these pulls.
      </li>
      <li>
        You also authorize NetCredit and/or Republic and/or TAB Bank and/or Quill Bank to verify
        information that you have provided, and you agree that NetCredit and/or Republic and/or TAB
        Bank and/or Quill Bank may contact third parties to verify such information. You direct
        NetCredit and/or Republic and/or TAB Bank and/or Quill Bank to use your credit reports to
        authenticate your identity, to make credit decisions, and for other related purposes.
      </li>
    </ul>
  ),
} as const;
